/**
 * @file IconData Icon
 * @author Auto Generated by @polyv/icons-cli
 */

import { IconBuilder } from '@polyv/icons-vue/icon-builder';

export default IconBuilder(
  'icon-data',
  (data) => `
<svg width="${data.size}" height="${data.size}" viewBox="0 0 48 48">
  <g
    fill="none"
    fill-rule="evenodd"
    stroke="none"
    stroke-width="${data.strokeWidth * 0.5}"
  >
    <rect width="48" height="48" x="0" y="0" />
    <g fill="${
      data.colorDesc[0]
    }" fill-rule="nonzero" transform="translate(8,8)">
      <path
        d="M30 30 30 32 4 32 4 30 30 30ZM32 0C33.10457 0 34 .89543 34 2L34 24C34 25.10457 33.10457 26 32 26L2 26C.89543 26 0 25.10457 0 24L0 2C0 .89543.89543 0 2 0L32 0ZM32 2 2 2 2 24 32 24 32 2Z"
      />
      <polygon points="12 10 12 18 10 18 10 10" />
      <polygon points="24 10 24 18 22 18 22 10" />
      <polygon points="18 6 18 18 16 18 16 6" />
    </g>
  </g>
</svg>
`
);
